export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8422.27df20ca.jpg";